import api from "../Interceptors/Interceptor";
import ApiResponse from "../Models/ApiResponse";
import {Page} from "../Models/Page";
import {AxiosResponse} from "axios";
import ReferenceModel from "../Models/ReferenceModel";

export interface IBaseService<F, C> {

    fetchItems(params?: {}): Promise<AxiosResponse<ApiResponse<Page<F>>>>;

    fetchItem(uuid: string): Promise<AxiosResponse<ApiResponse<C>>>;

    fetchSelectItems(): Promise<any>;

    postItem(item: C): Promise<any>;

    putItem(uuid: string, item: C): Promise<any>;

    deleteItem(uuid: string): Promise<any>;

}

export abstract class BaseService<F, C> implements IBaseService<F, C> {
    public async fetchItems(params?: {}): Promise<AxiosResponse<ApiResponse<Page<F>>>> {
        return await api.get(`v1/${this.modelUrl()}`, {
            params: params
        });
    }

    public async fetchItem(uuid: string): Promise<AxiosResponse<ApiResponse<C>>> {
        return await api.get(`v1/${this.modelUrl()}/${uuid}`);
    }

    public async fetchSelectItems(params?: {}): Promise<AxiosResponse<ApiResponse<ReferenceModel[]>>> {
        return await api.get(`v1/${this.modelUrl()}/select-item`,
            {
                params: params
            });
    }

    public async postItem(item: C): Promise<any> {
        return await api.post(`v1/${this.modelUrl()}`, item)
    }

    public async putItem(uuid: string, item: C): Promise<any> {
        return await api.put(`v1/${this.modelUrl()}/${uuid}`, item)
    }

    public async deleteItem(uuid: string): Promise<any> {
        return await api.delete(`v1/${this.modelUrl()}/${uuid}`)
    }

    protected abstract modelUrl(): string;
}